import type { Quake } from '../api/types';

// defensiveAdmit no longer enforces persistence as a client-side hard
// gate. Persistence is one reliability component in the heat model;
// the backend decides whether a row belongs in Confirmed or Watchlist.
//
// The return shape is kept so table callers do not need special-case
// compatibility code while the product moves from gate buckets to heat.
export function defensiveAdmit(movers: readonly Quake[]): {
  admitted: Quake[];
  leaked: Quake[];
} {
  return { admitted: [...movers], leaked: [] };
}

// Kept as a no-op compatibility hook for callers that still invoke it.
export function devWarnLeakedMovers(leaked: readonly Quake[]) {
  void leaked;
}
